// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__3vfrj","log":"ModalInventoryLogs_log__SMBpi","date":"ModalInventoryLogs_date__1wVQv","userName":"ModalInventoryLogs_userName__3FHUV"};